const getReadAloudContentDetails = (content, level) => {
  if (!content) return [];

  const title = level?.title ? `${level.title}. ` : "";
  const byline = level?.byline
    ? `${level.byline}. `
    : content?.author
      ? `By ${content.author}. `
      : "";
  const publicationDate = content?.display_published_at
    ? new Date(content.display_published_at)
    : "";
  const formattedDate = publicationDate
    ? `Published ${publicationDate.toLocaleDateString()}.`
    : "";

  return [
    ...(title ? [{ text: title, identifier: "title" }] : []),
    ...(byline ? [{ text: byline, identifier: "byline" }] : []),
    ...(formattedDate
      ? [{ text: formattedDate, identifier: "publishedAt" }]
      : []),
  ];
};

export default getReadAloudContentDetails;
